export default "__VITE_ASSET__IEA1V_Mn__"